import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "animate.css";
import { Fragment, useEffect, useRef, useState } from "react";
import PrivateRoute from "./PrivateRoute";
import { dashboardSideBar, sideBarLinks } from "./utils/constants";
import DefaultDashboard from "./layout/DefaultDashboard";
import PublicRoutes from "./layout/PublicRoutes";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  // NotFound,
  Dashboard,
  Login,
  RegisterPage,
  ForgotPassword,
  Purchase,
  About,
  Privacy,
  Terms,
  Cancellation,
  Shipping,
  Contact,
  CoinEarn,
  FractionsEarn,
  OnlinePurchase,
  Delegates,
  Community,
  // TeamAndPartners,
  ProposalList,
  ProposalForm,
  ProposalDetail,
  DeligatesDetails,
  Maintenance,
  DaoHome,
  TwitterOauth,
  ScannerDetails,
  DraftList,
  ReportTwo,
  Report,
  ReportOne,
  Scanner,
  ClubReport,
  FlagCommunication,
} from "./pages/pageListAsync";
import ReactGA from "react-ga4";
import { onMessageListener } from "./firebaseInit";
import { Toaster } from "react-hot-toast";
import Sitemap from "./Sitemap";
import DaoPrivateRoue from "./DaoPrivateRoue";
// import MetaTags from "./pages/MetaTags";
import { HelmetProvider } from "react-helmet-async";
import "./i18n";

import {
  EcoSystem,
  Landing,
  NotFound,
  Vision,
  ContactUs,
  // AboutUs,
  BlockValidationProcess,
  DaoAndMstChain,
  FractionalNode,
  Evm,
  Transparency,
  DynamicComp,
  Home,
  Blog,
  BlogDetails,
  NewDetails,
  News,
  // BuildWithMst,
  Contacts,
  PrivacyPolicy,
  TermsAndConditions,
  // CancellationW,
  KycPolicy,
  AmlPolicy,
  // TeamAndPartners,
  AboutW,
  // Event,
  BuildOnMST,
  MstResearchProgram,
  AboutNew,
} from "./containers/pageListAsync";
import {
  Ambassdor,
  DynamicTitle,
  LinkedinTracker,
  NotificationComponent,
  Notifications,
  PartnersPage,
  // PerspectiveGrid,
  TrackPageView,
  UserProfile,
  YouTubeLinkModal,
} from "./components";
import { setNotificationUpdate } from "./redux/Slice/notificationSlice";
import GlobalInternetHandler from "./components/GlobalInternetHandler";

const TrackingId = process.env.REACT_APP_TRACKING_ID;
const logClientId = () => {
  ReactGA.gtag("get", TrackingId, "client_id", () => {});
};
function App() {
  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT != "development") {
      ReactGA.send({
        hitType: "pageview",
        page: window?.location.pathname + window?.location.search,
      });
    }
  }, []);

  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT != "development") {
      logClientId();
    }
  }, []);

  const location = useLocation();
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState(null);
  const lastMessageIdRef = useRef(null);
  const { userData } = useSelector((state) => state?.user || {});
  const hasRedirected = useRef(false);
  const websiteDisable = false;
  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      window?.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  const getAccessToken = () => {
    const params = new URLSearchParams(location.search);
    const data = params.get("accessToken");
    if (data) {
      Cookies.set("accessToken", data);
      sessionStorage.setItem("referredAs", "User");
    }
  };
  useEffect(() => {
    getAccessToken();
  }, []);

  // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const CookiesData =
      sessionStorage.getItem("referredAs") == "User"
        ? Cookies.get("accessToken")
        : Cookies.get("pfaccessToken");
    const network = process.env.REACT_APP_NETWORK === "mainnet";
    if (
      userData &&
      network &&
      Object.keys(userData).length > 0 &&
      !userData?.isVerified &&
      CookiesData
    ) {
      navigate("/portal/kyc");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, userData?.isVerified]);

  useEffect(() => {
    const unsubscribe = onMessageListener((payload) => {
      if (
        payload?.messageId &&
        payload.messageId === lastMessageIdRef.current
      ) {
        return;
      }
      setNotification(payload);
      dispatch(setNotificationUpdate(true));
      setShow(true);
    });
    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      window?.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  useEffect(() => {
    if (userData?.email) {
      return;
    }
    const CookiesData =
      sessionStorage.getItem("referredAs") === "User"
        ? Cookies.get("accessToken")
        : Cookies.get("pfaccessToken");
    const isUserDataEmpty = Object.keys(userData).length !== 0;

    if (
      !hasRedirected.current &&
      isUserDataEmpty &&
      !userData?.email &&
      CookiesData
    ) {
      hasRedirected.current = false;
      navigate("/portal/profile", { replace: true });
    }
  }, [userData, userData?.email, location.pathname]);

  return (
    <>
      <HelmetProvider>
        {pathname.startsWith("/portal") ? (
          <ToastContainer toastStyle={{ zIndex: 9999 }} />
        ) : (
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover={false}
            theme="colored"
          />
        )}
        {(pathname.startsWith("/portal") || pathname.startsWith("/portal/")) &&
          websiteDisable && <Maintenance />}
        <Sitemap />
        <TrackPageView />
        <Notifications />
        <DynamicTitle />
        {/* {!pathname.startsWith("/portal") && <VideoPlay />} */}
        {!pathname.startsWith("/portal") && <LinkedinTracker />}
        {(pathname.startsWith("/portal") ||
          pathname.startsWith("/portal/")) && <YouTubeLinkModal />}
        {(pathname.startsWith("/portal") ||
          pathname.startsWith("/portal/")) && (
          <NotificationComponent
            notification={notification}
            show={show}
            setShow={setShow}
            setNotification={setNotification}
            lastMessageIdRef={lastMessageIdRef}
          />
        )}
        <Toaster reverseOrder={false} />
        {/* <MetaTags /> */}
        <GlobalInternetHandler />
        <Routes>
          <Route
            // index
            path="portal/register/:referralCode?"
            element={
              <PublicRoutes>
                {" "}
                <RegisterPage />
              </PublicRoutes>
            }
          ></Route>
          <Route
            path="portal/login"
            element={
              <PublicRoutes>
                {" "}
                <Login />
              </PublicRoutes>
            }
          ></Route>
          <Route
            path="portal/forgot-password"
            element={
              <PublicRoutes>
                {" "}
                <ForgotPassword />
              </PublicRoutes>
            }
          ></Route>
          <Route
            path="/portal"
            element={
              <PublicRoutes>
                <DefaultDashboard />
              </PublicRoutes>
            }
          >
            {sideBarLinks.map((item, index) => (
              <Route
                key={index}
                path={item.path}
                element={<Fragment>{item.component}</Fragment>}
              ></Route>
            ))}
            <Route path="about" element={<About />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="terms" element={<Terms />} />
            <Route path="cancellation" element={<Cancellation />} />
            <Route path="shipping" element={<Shipping />} />
            <Route path="contact" element={<Contact />} />
            <Route path="tokens-scan" element={<Scanner />} />
            <Route path="token/:address" element={<ScannerDetails />} />
          </Route>
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          >
            <Route index path="portal/dashboard" element={<Report />} />
            <Route path="portal/coin-earn" element={<CoinEarn />} />
            <Route path="portal/club-report" element={<ClubReport />} />
            <Route
              path="portal/flag-communication/:flagId"
              element={<FlagCommunication />}
            />
            <Route
              path="portal/fraction-earn/:date/:nodeId"
              element={<FractionsEarn />}
            ></Route>
            <Route
              index
              path="portal/purchase-receipt/:numberFraction"
              element={<Purchase />}
            />
            <Route
              index
              path="portal/dao/proposal-list"
              element={
                <DaoPrivateRoue>
                  <ProposalList />
                </DaoPrivateRoue>
              }
            />
            <Route
              index
              path="portal/dao/proposal-draft-list"
              element={
                <DaoPrivateRoue>
                  <DraftList />
                </DaoPrivateRoue>
              }
            />
            <Route
              path="portal/dao/proposal-form/:draftID?"
              element={
                <DaoPrivateRoue>
                  <ProposalForm />
                </DaoPrivateRoue>
              }
            />
            <Route
              index
              path="portal/dao/proposal-detail/:id/:proposalId"
              element={
                <DaoPrivateRoue>
                  <ProposalDetail />
                </DaoPrivateRoue>
              }
            />
            <Route
              index
              path="portal/dao/delegates"
              element={
                <DaoPrivateRoue>
                  <Delegates />
                </DaoPrivateRoue>
              }
            />
            <Route
              index
              path="portal/dao/delegate-detail/:id"
              element={
                <DaoPrivateRoue>
                  <DeligatesDetails />
                </DaoPrivateRoue>
              }
            />
            <Route
              index
              path="portal/dao"
              element={
                <DaoPrivateRoue>
                  <DaoHome />
                </DaoPrivateRoue>
              }
            />
            <Route
              index
              path="portal/online-purchase"
              element={<OnlinePurchase />}
            />
            <Route index path="portal/profile" element={<UserProfile />} />
            {/* <Route index path="dashboard" element={<DashboardLanding />}></Route> */}
            {/* <Route path="/report/:id?" element={<Report />}></Route> */}
            <Route path="portal/report/:id" element={<ReportOne />} />
            <Route path="portal/report/:id/:1231" element={<ReportTwo />} />
            <Route
              path="portal/twitter-oauth/code"
              element={<TwitterOauth />}
            />
            {dashboardSideBar.map(
              (item, index) =>
                item.title !== "Dashboard" && (
                  <Route
                    key={index}
                    path={item.path}
                    element={<Fragment>{item.component}</Fragment>}
                  />
                ),
            )}
          </Route>

          {/* <Route path="/grid" element={<PerspectiveGrid />} /> */}
          <Route path="/" element={<Landing />}>
            <Route index element={<Home />} />
            <Route path="/*" element={<NotFound />} />
            <Route path="/vision" element={<Vision />} />
            <Route path="/partnership" element={<PartnersPage />} />
            <Route path="/ecosystem" element={<EcoSystem />} />
            <Route path="/contact" element={<ContactUs />} />
            {/* <Route path="/about-mst" element={<AboutNew />} /> */}
            <Route
              path="/block-validation-process"
              element={<BlockValidationProcess />}
            />
            <Route path="/dao-and-mst-chain" element={<DaoAndMstChain />} />
            <Route path="/fractional-node" element={<FractionalNode />} />
            {/* <Route path="/build-on-mst" element={<BuildOnMST />} /> */}
            <Route path="/evm-blockchain" element={<Evm />} />
            <Route path="/ambassador-programme" element={<Ambassdor />} />
            <Route path="/transparency" element={<Transparency />} />
            {/* <Route path="/event" element={<Event />} /> */}
            <Route path="/solutions/:slug" element={<DynamicComp />} />
            <Route path="/blogs" element={<Blog />} />
            <Route path="/news" element={<News />} />
            <Route path="/blog-details/:slug" element={<BlogDetails />} />
            <Route path="/news-details/:slug" element={<NewDetails />} />
            <Route path="/build-with-mst" element={<BuildOnMST />} />
            {/* <Route path="/contact" element={<Contacts />} /> */}
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            {/* <Route path="/cancellation" element={<CancellationW />} /> */}
            <Route path="/kyc-policies" element={<KycPolicy />} />
            <Route path="/aml-policies" element={<AmlPolicy />} />
            {/* <Route path="/team-and-partners" element={<TeamAndPartners />} /> */}
            <Route path="/community" element={<Community />}></Route>
            <Route
              path="/mst-research-program"
              element={<MstResearchProgram />}
            ></Route>
            {/* <Route path="/about" element={<AboutNew />}></Route> */}
          </Route>

          {/* <Route path="/" element={<Landing />}> */}
          {/* <Route index element={<Home />} /> */}
          {/* <Route path="/*" element={<NotFounds />} /> */}

          {/* <Route path="/ecosystem" element={<EcoSystem />} /> */}
          {/* <Route path="/vision" element={<Vision />} /> */}
          {/* <Route path="/about-us" element={<AboutW />} /> */}
          {/* <Route path="/transparency" element={<Transparency />} /> */}

          {/* <Route path="/privacy" element={<Privacyy />} /> */}
          {/* <Route path="/terms" element={<TermsC />} /> */}

          {/* <Route path="/cancellation" element={<CancellationW />} /> */}
          {/* <Route path="/shipping" element={<Shippings />} /> */}
          {/* <Route path="/validator-benefits" element={<Validator />} /> */}
          {/* <Route path="/fortunx" element={<FortunX />} />/ */}
          {/* <Route path="/gaming" element={<Gaming />} /> */}
          {/* <Route path="/sattvashuffle" element={<Sattvashuffle />} /> */}
          {/* <Route path="/klethesia" element={<Klethesia />} /> */}
          {/* </Route> */}
        </Routes>
      </HelmetProvider>
    </>
  );
}

export default App;
